import { AlertDefinitionKey } from "./keys";

// Keys representing parameters displayed in the Main Panel
export type MainPanelParameterKey =
  | "swl"
  | "speed"
  | "mhLoad"
  | "mhRadius"
  | "maxRadius"
  | "swlPercentage"
  | "blockPosition"
  | "absTravel"
  | "relTravel"
  | "windSpeed"
  | "slewAngle"
  | "boomAngle";

// Configurable mapping: which alert definitions are considered related to each parameter
// Extend/adjust this list to control which alerts contribute to each parameter's badges
export const parameterRelatedAlerts: Record<
  MainPanelParameterKey,
  AlertDefinitionKey[]
> = {
  // Capacity and load
  swl: [
    AlertDefinitionKey.MAIN_HOIST_OVERLOAD,
    AlertDefinitionKey.OVERLOAD_PROTECTION,
  ],
  swlPercentage: [
    AlertDefinitionKey.MAIN_HOIST_OVERLOAD,
    AlertDefinitionKey.OVERLOAD_PROTECTION,
  ],
  mhLoad: [
    AlertDefinitionKey.MAIN_HOIST_OVERLOAD,
    AlertDefinitionKey.OVERLOAD_PROTECTION,
  ],

  // Motion/speed
  speed: [
    AlertDefinitionKey.MAIN_HOIST_DRIVE_ERROR,
    AlertDefinitionKey.BOOM_HOIST_DRIVE_ERROR,
    AlertDefinitionKey.SLEWING_DRIVE_ERROR,
    AlertDefinitionKey.OVERLOAD_PROTECTION,
  ],
  blockPosition: [
    AlertDefinitionKey.MAIN_HOIST_BLOCK_POSITION_HIGH,
    AlertDefinitionKey.MAIN_HOIST_BLOCK_POSITION_PRE_HIGH,
  ],

  // Geometry / angles / radius
  mhRadius: [
    AlertDefinitionKey.BOOM_HOIST_ANGLE_ERROR,
    AlertDefinitionKey.SLEWING_ANGLE_ERROR,
  ],
  maxRadius: [
    AlertDefinitionKey.BOOM_HOIST_ANGLE_ERROR,
    AlertDefinitionKey.SLEWING_ANGLE_ERROR,
  ],
  slewAngle: [
    AlertDefinitionKey.SLEWING_ANGLE_ERROR,
    AlertDefinitionKey.SLEWING_DRIVE_ERROR,
    AlertDefinitionKey.SLEWING_BRAKE_ERROR,
  ],
  boomAngle: [
    AlertDefinitionKey.BOOM_HOIST_ANGLE_ERROR,
    AlertDefinitionKey.BOOM_HOIST_DRIVE_ERROR,
    AlertDefinitionKey.BOOM_HOIST_BRAKE_ERROR,
  ],

  // Travel
  absTravel: [AlertDefinitionKey.GENERAL_SENSOR_ERROR],
  relTravel: [AlertDefinitionKey.GENERAL_SENSOR_ERROR],

  // Environment
  windSpeed: [AlertDefinitionKey.HIGH_WIND_SPEED],
};
